import React, { Component } from 'react'
import Slider from 'react-slick';

// Custom arrow components
const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="news-arrow news-prev" onClick={onClick}>
            ←
        </button>
    );
};

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <button className="news-arrow news-next" onClick={onClick}>
            →
        </button>
    );
};

class SleepNews extends Component {
    render() {
        const settings = {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            arrows: true,
            prevArrow: <PrevArrow />,
            nextArrow: <NextArrow />,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    arrows: true
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                  }
                }
              ]
        };

        return (
            <section className="brand-logo-wrapper vVedioBlock news-slider-section">
                <div className="container">
                    <div className="row">
                        <div className='col-md-12 my-lg-4 my-4 text-center'>
                            <h2>Our Latest News</h2>
                        </div>
                        <div className="col-md-12">
                            <Slider className="brand-logo-carousel" {...settings}>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/4pzf1Utze5E" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/HFxbW6Hr9WU?si=8mZDLFtgpzSzM_0Z" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/ApfYTkiaM_c" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/yCiGu-WOL2s" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/J94Z40h52Ns" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/pNC--htFaSM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/4KQaCuWGn1w" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/_mpyYfAwRvc" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                                <div className="single-brand-logo videoSpace">
                                    <div className="video-wrapper">
                                        <iframe src="https://www.youtube.com/embed/D4zaYVYir5E" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default SleepNews
